
import  DaneServices  from '../api/Dane/api-dane'

export const useRegitrarUsuarioUME = () => {

    const guardarUsuario = async(usuarioRegitrar: any) => {
        const response = await  DaneServices.guardarUsuario(usuarioRegitrar)
        return response;
    }

    const cambiarContraseniaUsuario = async (doc_number: string, password: string, new_password: string) => {


        let cambiarContraseñia = {
            doc_number,
            password,
            new_password
        }

        const response = await  DaneServices.cambiarContraseniaUsuario(cambiarContraseñia)
        return response;


    }

    const recuperarContrasenia = async (documento: string, correo: string, ) => {

        let data = {
            documento,
            correo
        }

        const response = await  DaneServices.recuperarContrasenia(data)
        return response;

    }


    const iniciarSesion = (usuario: string, contra: string) => {
    }





    return {
        guardarUsuario,
        cambiarContraseniaUsuario,
        iniciarSesion,
        recuperarContrasenia
    }





}
